module.exports = __webpack_public_path__ + "img/428837.6802d239.png";